import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import JSZip from 'jszip';
import Papa from 'papaparse';
import './EditTenantModal.css';
import { useDispatch } from 'react-redux';
import { updateImageFileName, setPendingTheme } from '../../store/themeSlice';

const EditTenantModal = ({ tenant, onClose, onSave }) => {
  const [name, setName] = useState(tenant?.TenantName || '');
  const [brandingFile, setBrandingFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  const [extractedXlsxFile, setExtractedXlsxFile] = useState(null);
  const [extractedImageFile, setExtractedImageFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.name.endsWith('.zip')) {
      setBrandingFile(file);
      setErrorMessage('');
    } else if (file) {
      setBrandingFile(null);
      setErrorMessage('Only ZIP files are supported.');
    } else {
      setBrandingFile(null);
      setErrorMessage('');
    }
  };

   const handleSaveClick = () => {
    if (!name.trim()) {
      setErrorMessage('Tenant name is required.');
      return;
    }

    onSave(tenant, name.trim(), brandingFile); 
    onClose();
  };

  return (
    <div className="edit-tenant-backdrop">
      <div className="edit-tenant-modal">
        <h2>Edit Tenant</h2>

        <div className="edit-tenant-input-group">
          <label className="edit-tenant-label">Name</label>
          <input
            type="text"
            placeholder="Enter tenant name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="edit-tenant-input"
          />
        </div>

        <div className="edit-tenant-input-group">
          <label className="edit-tenant-label">Branding File (.zip)</label>
          <input
            type="file"
            accept=".zip"
            onChange={handleFileChange}
            className="edit-tenant-input"
            data-testid="branding-file-input"
          />
          {brandingFile && <p className="current-file">New File: {brandingFile.name}</p>}
          {errorMessage && <p className="error-message">{errorMessage}</p>}
        </div>

        <div className="edit-tenant-actions">
          <button onClick={onClose} className="edit-tenant-button cancel">
            Cancel
          </button>
          <button onClick={handleSaveClick} className="edit-tenant-button save">
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditTenantModal;
